import { makeStyles } from "@material-ui/core/styles";
import { useContext } from "react";
import { ThemeContext } from "../../../Context/Theme";

export const useSettingStyles = () => {
  const { dark } = useContext(ThemeContext);
  const useStyles = makeStyles((theme) => ({
    typographyStyles: {
      color: dark ? theme.palette.primary.main : "#747474",
      fontWeight: "bolder",
    },
    statusDiv: {
      display: "flex",
      margin: "10px 0px",
    },
    mt30: {
      marginTop: 30,
    },
    mt40: {
      marginTop: 40,
    },
    mb20: {
      marginBottom: 20,
    },
    mt10: {
      marginTop: 10,
    },
    tooltip: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 400,
      fontSize: 18,
      border: "1px solid #dadde9",
    },
    mt5: {
      marginTop: 5,
    },
    flexBtw: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    mt20: {
      marginTop: 20,
    },
    ml10: {
      marginLeft: 10,
    },
    mb10: {
      marginBottom: 10,
    },
    center: {
      textAlign: "center",
    },
    addLicenseBtnContainer: {
      display: "flex",
      marginBottom: "2rem",
      justifyContent: "flex-end",
      alignItems: "center",
    },
    paperStyles: {
      backgroundColor: dark ? "#212121" : "#f2f2f2",
      padding: 20,
    },
    paperStyleIcons: {
      marginTop: 20,
      backgroundColor: "rgba(255, 255, 204, 0.3)",
      padding: 20,
      marginBottom: 20,
    },
    stepper: {
      backgroundColor: dark ? "#212121" : "#f2f2f2",
    },
    inputStyle: {
      padding: "0.5rem",
      fontSize: "1.5rem",
      width: "100%",
    },
    textFieldStyles: {
      "&:focus": {
        border: "1px solid #445B6E",
      },
    },
    checkboxStyles: {
      color: dark ? theme.palette.primary.main : "#747474",
    },

    delUserBtn: {
      color: "white",
      background: "#C80815",

      "&:hover": {
        background: "#a00610",
      },
    },
  }));
  const classes = useStyles();
  return classes;
};
